import React from 'react';
import defaultContext from './defaultContext';

const AppContext = React.createContext({
  locale: defaultContext.defaultLng,
  selectedFont: defaultContext.selectedFont,
  setLocale: () => {},
  setSelectedFont: () => {},
});

export default AppContext;
